// @flow
import moment from 'moment';

const mergeDateAndTime = (date: moment, time: moment): moment => {
  const mergedDate = date.clone();
  mergedDate.set({
    hour: time.get('hour'),
    minute: time.get('minute'),
    second: time.get('second'),
  });

  return mergedDate;
};

export default mergeDateAndTime;



// WEBPACK FOOTER //
// ./src/common/helpers/mergeMoment.js